import TimeFrameSelect from "pages/Dashboard/components/TimeFrameSelect";

import { TimeFrame, TIME_FRAME_OPTIONS } from "../../timeFrame";

interface RedeFiltersProps {
  timeFrame: { value: TimeFrame; label: string };
  setTimeFrame: (v: { value: TimeFrame; label: string }) => void;
  doctors: { id: number; name: string }[];
  selectedDoctorId: number | null;
  setSelectedDoctorId: (id: number | null) => void;
}

export default function RedeFilters({
  timeFrame,
  setTimeFrame,
  doctors,
  selectedDoctorId,
  setSelectedDoctorId,
}: RedeFiltersProps) {
  return (
    <div className="row justify-content-lg-end gx-2">
      <div className="col-12 col-sm-6 col-md-4 pb-2">
        <TimeFrameSelect
          value={timeFrame}
          options={TIME_FRAME_OPTIONS}
          defaultValue={{ value: TimeFrame.LastWeek, label: "Última semana" }}
          setValue={setTimeFrame}
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 pb-2">
        <select
          className="form-select"
          style={{ height: 48 }}
          aria-label="Filtrar por médico"
          value={selectedDoctorId ?? ""}
          onChange={(e) =>
            setSelectedDoctorId(e.target.value ? Number(e.target.value) : null)
          }
        >
          <option value="">Todos os médicos</option>
          {doctors.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
